// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
